import { render, staticRenderFns } from "./avalonNewsEditor.vue?vue&type=template&id=041dfc7c&scoped=true&"
import script from "./avalonNewsEditor.vue?vue&type=script&lang=js&"
export * from "./avalonNewsEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "041dfc7c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VSheet,VTextarea})
